<script>
  import { urlServeur } from "../conf";

  // test chargement de fihier et envoi vers api

  let avatar,
    fileinput,
    titreBtn = "Afficher uplaod";
  let visuUpload = false;
  /**
   *
   * @param e
   */
  const onFileSelected = (e) => {
    // converti l'image en base 64
    //console.log(fileinput);
    let image = e.target.files[0]; //info finder de l'image
    //console.log(image);
    let reader = new FileReader(); // pas de retour
    reader.readAsDataURL(image);

    reader.onload = (e) => {
      avatar = e.target.result; // => avatar.split(",") => [0] = type, [1]= data brut
      ssSendImage(image, avatar);
    };
  };

  /**
   * Sous_program
   * @param image
   */
  const ssSendImage = (image, data) => {
    let formData = new FormData();
    formData.append("imagesvelte", image); // ???????   ou image

    // visuFormData(formData); // affichage dans la console

    // ======================
    fetch(urlServeur + "/api/permis/uploadfileimg", {
      method: "POST",
      mode: "no-cors",
      body: formData,
    })
      .then(function (response) {
        if (!response.ok) {
          console.log("New Error: " + response.ok);
          throw new Error("unable to load " + JSON.stringify(response));
        }
        return response.json();
      })
      .then(function (data) {
        console.log("Success " + data.result);
      })
      .catch((error) => {
        console.log("Error: " + error);
      });
  };

  /**
   *
   * @param formdataObj
   */
  const visuFormData = (formdataObj) => {
    for (let [name, value] of formdataObj) {
      console.log(`${name} = ${value}`); // key1 = value1, ensuite key2 = value2
    }
  };

  const toggleVisuUpload = () => {
    visuUpload = !visuUpload;
    if (visuUpload) {
      titreBtn = "Cacher Upload";
    } else {
      titreBtn = "Afficher Upload";
    }
  };
</script>

<!-- ****************************** -->
<div class="row">
  <button class="btn btn-info" on:click={toggleVisuUpload}>{titreBtn}</button>
</div>
{#if visuUpload}
  <h1>Upload Image</h1>

  {#if avatar}
    <img class="avatar" src={avatar} alt="d" />
  {:else}
    <img
      class="avatar"
      src="https://cdn4.iconfinder.com/data/icons/small-n-flat/24/user-alt-512.png"
      alt=""
    />
  {/if}

  <form>
    <input
      type="file"
      accept=".jpg, .jpeg, .png"
      on:change={(e) => onFileSelected(e)}
      bind:this={fileinput}
    />
  </form>
{/if}

<style>
  .avatar {
    display: flex;
    height: 200px;
    width: 200px;
  }
</style>
